export default __webpack_public_path__ + "static/media/logo.c21474d9.png";